import { lazy, Suspense } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useStore } from '../../domain/users/store';
import { Public_Routes } from '../constants';
import { NotFoundPublicRoutes } from '../router';
import { PageTransition } from '../../ui/shared/page-transition';
import 'react-toastify/dist/ReactToastify.css';

const LoginPage = lazy(() => import('../../ui/user/login/pages/LoginPage'));
const AuthRouter = lazy(() => import('./AuhtLayout'));

function App() {
    const { commonStore } = useStore();

    return (
        <Suspense fallback={<PageTransition />}>
            <BrowserRouter>
                <>
                    {commonStore.token ? (
                        <>
                            <AuthRouter />
                            <ToastContainer />
                        </>
                    ) : (
                        <NotFoundPublicRoutes redirect={Public_Routes.LOGIN}>
                            <Route
                                path={Public_Routes.LOGIN}
                                element={<LoginPage />}
                            />
                        </NotFoundPublicRoutes>
                    )}
                </>
            </BrowserRouter>
        </Suspense>
    );
}

export default App;
